<div class="paste-area" *ngIf="canRenderPasteArea()"
     (paste)="handlePaste($event)"
     (click)="onClick()"
     (mouseleave)="onBlur()">
    <span *ngIf="focused"
          class="message ok">
        <p>{{ 'admin.strain.common.excelPaste.copyPasteTable.focused.instructions' | translate }} </p>
        <p>{{ 'admin.strain.common.excelPaste.copyPasteTable.focused.info' | translate }} </p>
    </span>
    <span *ngIf="!focused"
          class="message not-ok">
        {{ 'admin.strain.common.excelPaste.copyPasteTable.notFocused' | translate }}
    </span>
</div>

<div *ngIf="canRenderTable()">
    <app-table [data]="data">
        <app-table-column *ngFor="let column of columns"
                          header="{{('admin.strain.common.excelPaste.columns.' + column.value) | translate}}"
                          field="{{column.value}}">
        </app-table-column>
    </app-table>
    <app-button type="primary" (click)="handleReset()">
        <i class="fa fa-undo"></i>
    </app-button>
</div>
